export default {
  UNAUTHORIZED:  "UNAUTHORIZED",
  FORBIDDEN:     "FORBIDDEN",
  UNKNOWN_ERROR: "An unknown error has occurred.",
  TYPE_STUDENT: "student_user",
  TYPE_TEACHER: "teacher_user",
  TYPE_QUESTIONNAIRE: "questionnaire_user",
  TYPE_ADMIN: "admin_user",
};